import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Check, ClipboardList, BarChart3, Wrench, Trophy, LayoutDashboard, Moon } from 'lucide-react';
export function ProductPresentation() {
  const ebookFeatures = ['Los 3 pilares científicos de la longevidad ejecutiva explicados paso a paso', 'Plan de acción de 30 días con protocolo diario exacto', 'La Matriz de Suplementos: solo lo que la ciencia respalda (no basura)', 'Los 3 Jinetes del Envejecimiento: qué eliminar y por qué', 'Protocolo de Hormesis Térmica (duchas frías + calor)', 'Sistema de Arquitectura Dopaminérgica para enfoque láser', 'Higiene de Fotones: reprograma tu reloj biológico', 'Box Breathing y gestión de cortisol entre reuniones'];
  const appFeatures = [{
    icon: <ClipboardList className="w-8 h-8 text-brand-cyan" data-id="element-505" />,
    title: 'Protocolo Diario Interactivo',
    desc: 'Checklist día a día con timer integrado. Marca cada acción completada. Celebración al terminar.'
  }, {
    icon: <BarChart3 className="w-8 h-8 text-brand-purple" data-id="element-506" />,
    title: 'Tracker de Progreso',
    desc: 'Registra energía, sueño, claridad mental. Gráficos de tendencia. Ve tu transformación en números reales.'
  }, {
    icon: <Wrench className="w-8 h-8 text-brand-gold" data-id="element-507" />,
    title: 'Caja de Herramientas',
    desc: 'Calculadora de ayuno, protocolo de frío, guías rápidas deslizables, base de datos de suplementos y alimentos.'
  }, {
    icon: <Trophy className="w-8 h-8 text-brand-red" data-id="element-508" />,
    title: 'Gamificación Completa',
    desc: 'Rachas, badges, XP, niveles. Motivación estilo Duolingo para que nunca abandones el protocolo.'
  }, {
    icon: <LayoutDashboard className="w-8 h-8 text-brand-cyan" data-id="element-509" />,
    title: 'Dashboard Premium',
    desc: 'Tu score Bio-X, progreso del día, insight científico diario, siguiente acción pendiente. Todo en una pantalla.'
  }, {
    icon: <Moon className="w-8 h-8 text-brand-purple" data-id="element-510" />,
    title: 'Dark Mode Premium',
    desc: 'Diseño visual nivel Whoop/Oura. Se siente como una herramienta de $100/mes, no como un blog bonito.'
  }];
  return <section className="py-24 px-6 bg-brand-bg-alt relative overflow-hidden" data-id="element-511">
      {/* Subtle radial background */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[1000px] bg-brand-cyan/5 rounded-full blur-[150px] pointer-events-none" data-id="element-512" />

      <div className="max-w-[1200px] mx-auto relative z-10" data-id="element-513">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-514">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4" data-id="element-515">
            Te Presento: El Ecosistema BIO-X 90 Completo
          </h2>
          <p className="text-xl text-brand-muted max-w-[700px] mx-auto" data-id="element-516">
            El primer sistema de longevidad para ejecutivos que combina
            CONOCIMIENTO + HERRAMIENTA INTERACTIVA
          </p>
        </motion.div>

        {/* EBOOK SECTION */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-brand-card rounded-[24px] border-t-4 border-brand-cyan p-8 md:p-12 mb-24 shadow-2xl" data-id="element-517">
          <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-518">
            {/* Left: Ebook Mockup */}
            <div className="w-full lg:w-[40%] flex justify-center" data-id="element-519">
              <div className="relative w-full max-w-[320px]" data-id="element-520">
                <div className="absolute inset-0 bg-brand-cyan/20 rounded-2xl blur-[60px] scale-90 pointer-events-none" data-id="element-521" />
                <img src="https://cdn.magicpatterns.com/uploads/7GpfTKkoYQAXibRxBZxYB2/book3.png" alt="BIO-X 90: The 80/20 Longevity Protocol — Digital Product Prestige Edition" className="relative w-full drop-shadow-[0_30px_50px_rgba(0,212,170,0.2)] rounded-md" loading="lazy" data-id="element-522" />
              </div>
            </div>

            {/* Right: Ebook Details */}
            <div className="w-full lg:w-[60%]" data-id="element-523">
              <span className="inline-block px-3 py-1 bg-brand-cyan/20 text-brand-cyan text-xs font-bold rounded-full mb-4" data-id="element-524">
                📖 PRODUCTO PRINCIPAL
              </span>
              <h3 className="text-3xl font-bold text-white mb-2" data-id="element-525">
                El Blueprint Bio-X 90
              </h3>
              <p className="text-lg text-brand-muted mb-2" data-id="element-526">
                El mapa exacto para resetear tu metabolismo en 90 días
              </p>
              <p className="text-brand-muted line-through mb-8 font-mono" data-id="element-527">
                Valor: $197
              </p>

              <div className="grid sm:grid-cols-2 gap-y-4 gap-x-6" data-id="element-528">
                {ebookFeatures.map((feat, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-529">
                    <div className="mt-1 bg-green-500/20 p-0.5 rounded-full shrink-0" data-id="element-530">
                      <Check className="w-4 h-4 text-green-500" data-id="element-531" />
                    </div>
                    <p className="text-sm text-white/90 leading-relaxed" data-id="element-532">
                      {feat}
                    </p>
                  </div>)}
              </div>
            </div>
          </div>
        </motion.div>

        {/* PRE-REVEAL TRANSITION */}
        <div className="relative py-12 mb-12 text-center" data-id="element-533">
          <div className="absolute top-1/2 left-0 w-full h-px bg-gradient-to-r from-transparent via-brand-purple to-transparent" data-id="element-534" />
          <span className="relative z-10 bg-brand-bg-alt px-6 text-lg font-medium text-brand-muted italic" data-id="element-535">
            Pero eso no es todo. Aquí es donde nos volvemos DIFERENTES a
            cualquier otro ebook del mercado...
          </span>
        </div>

        {/* APP REVEAL CARD */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative bg-gradient-to-b from-brand-card to-brand-bg-alt rounded-[24px] p-8 md:p-16 border-2 border-brand-purple shadow-[0_0_60px_rgba(123,104,238,0.2)] text-center mb-20" data-id="element-536">
          <div className="absolute -top-5 left-1/2 -translate-x-1/2" data-id="element-537">
            <span className="inline-block bg-gradient-to-r from-brand-gold to-[#FFA502] text-black font-black px-6 py-2 rounded-full text-sm tracking-wide animate-pulse-slow shadow-lg" data-id="element-538">
              🚀 NUEVO — INCLUIDO GRATIS
            </span>
          </div>

          <h3 className="text-4xl md:text-6xl font-black text-white mb-6 mt-4" data-id="element-539">
            La App Interactiva BIO-X 90™
          </h3>
          <p className="text-xl md:text-2xl text-brand-cyan font-medium mb-4" data-id="element-540">
            Tu protocolo de 90 días en el bolsillo. Soluciones instantáneas, no
            200 páginas por leer.
          </p>
          <p className="text-brand-muted line-through font-mono mb-8" data-id="element-541">
            Valor: $297
          </p>

          <p className="text-lg text-white/90 max-w-[800px] mx-auto leading-relaxed" data-id="element-542">
            La app que transforma el ebook en{' '}
            <strong className="text-brand-cyan" data-id="element-543">ACCIÓN</strong>. En lugar de
            leer y recordar, abres la app y ella te dice EXACTAMENTE qué hacer
            hoy. Paso a paso. Con timer. Con tracking. Con celebraciones.
          </p>
        </motion.div>

        {/* APP FEATURES GRID */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-24" data-id="element-544">
          {appFeatures.map((feat, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-brand-card-hover rounded-2xl p-6 border border-brand-border" data-id="element-545">
              <div className="mb-4" data-id="element-546">{feat.icon}</div>
              <h4 className="text-lg font-bold text-white mb-2" data-id="element-547">
                {feat.title}
              </h4>
              <p className="text-sm text-brand-muted leading-relaxed" data-id="element-548">
                {feat.desc}
              </p>
            </motion.div>)}
        </div>

        {/* APP MOCKUPS */}
        <div className="flex flex-col lg:flex-row justify-center items-center gap-12 lg:gap-20" data-id="element-549">
          {/* Mockup 1: Dashboard */}
          <motion.div initial={{
          opacity: 0,
          x: -30,
          rotateY: 10
        }} whileInView={{
          opacity: 1,
          x: 0,
          rotateY: -5
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative w-[280px] h-[560px] bg-brand-bg rounded-[40px] border-[4px] border-brand-border p-4 shadow-2xl overflow-hidden" style={{
          perspective: '1000px',
          transformStyle: 'preserve-3d'
        }} data-id="element-550">
            <div className="absolute inset-0 bg-brand-cyan/5 pointer-events-none" data-id="element-551" />

            {/* App Header */}
            <div className="flex justify-between items-center mb-6" data-id="element-552">
              <span className="font-bold text-white text-sm" data-id="element-553">🧬 BIO-X 90</span>
              <span className="text-brand-muted" data-id="element-554">⚙️</span>
            </div>

            {/* Hero Card */}
            <div className="bg-brand-card rounded-xl p-4 mb-4 border border-brand-border" data-id="element-555">
              <p className="text-white font-bold mb-2" data-id="element-556">Día 8 de 90</p>
              <div className="w-full h-2 bg-brand-bg rounded-full overflow-hidden" data-id="element-557">
                <div className="w-[9%] h-full bg-brand-cyan rounded-full" data-id="element-558" />
              </div>
            </div>

            {/* Mini Stats */}
            <div className="flex gap-2 mb-4" data-id="element-559">
              <div className="flex-1 bg-brand-card rounded-lg p-2 text-center border border-brand-border" data-id="element-560">
                <p className="text-xs text-brand-muted mb-1" data-id="element-561">Energía</p>
                <p className="text-sm font-bold text-white" data-id="element-562">⚡7/10</p>
              </div>
              <div className="flex-1 bg-brand-card rounded-lg p-2 text-center border border-brand-border" data-id="element-563">
                <p className="text-xs text-brand-muted mb-1" data-id="element-564">Racha</p>
                <p className="text-sm font-bold text-white" data-id="element-565">🔥 8</p>
              </div>
              <div className="flex-1 bg-brand-card rounded-lg p-2 text-center border border-brand-border" data-id="element-566">
                <p className="text-xs text-brand-muted mb-1" data-id="element-567">Score</p>
                <p className="text-sm font-bold text-white" data-id="element-568">📊 6.8</p>
              </div>
            </div>

            {/* Fake Chart */}
            <div className="bg-brand-card rounded-xl p-4 mb-4 border border-brand-border h-[80px] relative overflow-hidden" data-id="element-569">
              <div className="absolute bottom-0 left-0 w-full h-[40px] bg-gradient-to-t from-brand-purple/20 to-transparent" data-id="element-570" />
              <svg className="absolute bottom-0 left-0 w-full h-[40px]" preserveAspectRatio="none" viewBox="0 0 100 100" data-id="element-571">
                <path d="M0,100 L0,50 L20,70 L40,30 L60,60 L80,20 L100,40 L100,100 Z" fill="rgba(123,104,238,0.3)" data-id="element-572" />
                <path d="M0,50 L20,70 L40,30 L60,60 L80,20 L100,40" fill="none" stroke="#7B68EE" strokeWidth="2" data-id="element-573" />
              </svg>
            </div>

            {/* Insight Card */}
            <div className="bg-brand-cyan/10 rounded-xl p-3 border border-brand-cyan/20" data-id="element-574">
              <p className="text-[10px] text-brand-cyan leading-tight" data-id="element-575">
                🧠 <strong data-id="element-576">Insight:</strong> Tu cerebro es 60% grasa. El Omega-3
                es su combustible principal.
              </p>
            </div>

            {/* Bottom Nav */}
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-4 bg-brand-card px-6 py-3 rounded-full border border-brand-border" data-id="element-577">
              <div className="w-2 h-2 rounded-full bg-brand-cyan" data-id="element-578" />
              <div className="w-2 h-2 rounded-full bg-brand-muted" data-id="element-579" />
              <div className="w-2 h-2 rounded-full bg-brand-muted" data-id="element-580" />
              <div className="w-2 h-2 rounded-full bg-brand-muted" data-id="element-581" />
            </div>
          </motion.div>

          {/* Mockup 2: Protocol */}
          <motion.div initial={{
          opacity: 0,
          x: 30,
          rotateY: -10
        }} whileInView={{
          opacity: 1,
          x: 0,
          rotateY: 5
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative w-[280px] h-[560px] bg-brand-bg rounded-[40px] border-[4px] border-brand-border p-4 shadow-2xl overflow-hidden" style={{
          perspective: '1000px',
          transformStyle: 'preserve-3d'
        }} data-id="element-582">
            <div className="absolute inset-0 bg-brand-purple/5 pointer-events-none" data-id="element-583" />

            {/* App Header */}
            <div className="text-center mb-6 mt-2" data-id="element-584">
              <span className="font-bold text-white text-sm" data-id="element-585">
                Protocolo Diario — Día 8
              </span>
            </div>

            {/* Calendar Row */}
            <div className="flex justify-between items-center mb-6 px-2" data-id="element-586">
              <span className="text-xs text-brand-muted" data-id="element-587">L</span>
              <span className="text-xs text-brand-muted" data-id="element-588">M</span>
              <div className="w-6 h-6 rounded-full bg-brand-cyan flex items-center justify-center" data-id="element-589">
                <span className="text-xs text-black font-bold" data-id="element-590">X</span>
              </div>
              <span className="text-xs text-brand-muted" data-id="element-591">J</span>
              <span className="text-xs text-brand-muted" data-id="element-592">V</span>
              <span className="text-xs text-brand-muted" data-id="element-593">S</span>
              <span className="text-xs text-brand-muted" data-id="element-594">D</span>
            </div>

            {/* Progress */}
            <div className="mb-6" data-id="element-595">
              <div className="flex justify-between text-xs mb-1" data-id="element-596">
                <span className="text-white" data-id="element-597">Progreso</span>
                <span className="text-brand-cyan font-bold" data-id="element-598">75%</span>
              </div>
              <div className="w-full h-1.5 bg-brand-card rounded-full overflow-hidden" data-id="element-599">
                <div className="w-[75%] h-full bg-brand-cyan rounded-full" data-id="element-600" />
              </div>
            </div>

            {/* Checklist */}
            <div className="space-y-3" data-id="element-601">
              <div className="bg-brand-card rounded-xl p-3 border border-brand-border flex items-center gap-3" data-id="element-602">
                <div className="w-4 h-4 rounded-full border-2 border-brand-cyan" data-id="element-603" />
                <span className="text-sm text-white" data-id="element-604">Ventana ayuno 16:8</span>
              </div>
              <div className="bg-brand-card rounded-xl p-3 border border-brand-border flex items-center gap-3" data-id="element-605">
                <div className="w-4 h-4 rounded-full border-2 border-brand-purple" data-id="element-606" />
                <span className="text-sm text-white" data-id="element-607">Magnesio glicinato</span>
              </div>
              <div className="bg-brand-card rounded-xl p-3 border border-brand-cyan/50 bg-brand-cyan/5 flex items-center gap-3 opacity-60" data-id="element-608">
                <div className="w-4 h-4 rounded-full bg-brand-cyan flex items-center justify-center" data-id="element-609">
                  <Check className="w-3 h-3 text-black" data-id="element-610" />
                </div>
                <span className="text-sm text-white line-through" data-id="element-611">
                  Ducha fría 90 seg
                </span>
              </div>
              <div className="bg-brand-card rounded-xl p-3 border border-brand-border flex items-center gap-3" data-id="element-612">
                <div className="w-4 h-4 rounded-full border-2 border-brand-gold" data-id="element-613" />
                <span className="text-sm text-white" data-id="element-614">Cero pantallas PM</span>
              </div>
            </div>

            {/* Bottom Nav */}
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-4 bg-brand-card px-6 py-3 rounded-full border border-brand-border" data-id="element-615">
              <div className="w-2 h-2 rounded-full bg-brand-muted" data-id="element-616" />
              <div className="w-2 h-2 rounded-full bg-brand-cyan" data-id="element-617" />
              <div className="w-2 h-2 rounded-full bg-brand-muted" data-id="element-618" />
              <div className="w-2 h-2 rounded-full bg-brand-muted" data-id="element-619" />
            </div>
          </motion.div>
        </div>

        {/* Mid-page CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mt-24 bg-brand-cyan/10 rounded-2xl p-8 text-center max-w-[600px] mx-auto border border-brand-cyan/20" data-id="element-620">
          <h4 className="text-xl font-bold text-white mb-6" data-id="element-621">
            ¿Listo para empezar tu transformación?
          </h4>
          <a href="https://pay.hotmart.com/X105898119V" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full sm:w-auto px-8 h-[56px] rounded-xl bg-gradient-to-r from-brand-cyan to-brand-purple text-white font-bold hover:scale-[1.02] transition-transform shadow-lg" data-id="element-622">
            Acceso completo por $6.36 →
          </a>
        </motion.div>
      </div>
    </section>;
}